import React, { useState, useEffect } from 'react';
import { Box } from '@material-ui/core';
import { useTranslate } from 'react-admin';
import CustomPoper from '../CustomizedUIs/CustomPoperCalendar';
import OneLineTextField from '../CustomizedUIs/CustomTextFiled';
import { useSelector, useDispatch } from 'react-redux';
import { changeNodeGlobalData } from '../redux/actions/tree-action';
import { WIFI_ENCRYPTION_TYPES, LIST_INPUT } from '../utils';
import SelectBoxFilter from '../common/select-box-filter'

function getInputDeviceLabel(id, translate) {
    const foundItem = LIST_INPUT.find(item => item.id === id);
    return foundItem ? translate(foundItem.label) : '';
}

function GenericQRCaster() {
    const translate = useTranslate();
    const dispatch = useDispatch();

    const LIST_INPUT_DEVICE = LIST_INPUT.filter(item => item.qrCasterOnly).map(item => ({
        ...item,
        label: translate(item.label)
    }));

    const [openPoper, setOpenPopper] = useState(false);
    const { isEditing, nodeSelected } = useSelector(state => state.tree);
    const { nodeApplication } = nodeSelected.applicationData;
    const { genericQRCaster } = nodeApplication;
    const { pairingURL, wifiSSID, castDeviceName, wifiPassword, wifiEncryptionType, castDeviceInput } = genericQRCaster;

    const onChangeQRCaster = (data) => {
        const newNode = {
            ...nodeSelected.applicationData,
            nodeApplication: {
                ...nodeApplication,
                genericQRCaster: {
                    ...genericQRCaster,
                    ...data
                }
            }
        };
        dispatch(changeNodeGlobalData(newNode));
    }

    const textOnChange = prop => (e) => {
        onChangeQRCaster({ [prop]: e.target.value });
    }

    useEffect(() => {
        onChangeQRCaster({
            wifiEncryptionType: wifiEncryptionType || WIFI_ENCRYPTION_TYPES[0].name,
            castDeviceInput: castDeviceInput || LIST_INPUT_DEVICE[0].id
        });
    }, []);

    return (
        <Box>
            <Box mt={3.5} >
                <OneLineTextField
                    disabled={!isEditing}
                    id="filled-basic"
                    label={translate('resources.infoPage.genericQRCaster.cast_paring_url')}
                    value={pairingURL}
                    onChange={textOnChange('pairingURL')}
                    style={{ width: 500 }}
                    endDom={<CustomPoper
                        color={'#e5f1f8'}
                        fontSize={'11px'}
                        open={openPoper}
                        handleClick={() => setOpenPopper(true)}
                        handleClose={() => setOpenPopper(false)}
                        title={translate('resources.infoPage.genericQRCaster.cast_paring_url')}
                        content={translate('resources.infoPage.genericQRCaster.cast_paring_url_content')}
                        icon={<b>?</b>}
                    />}
                />
            </Box>
            <Box style={{ marginTop: 20 }} >
                <OneLineTextField
                    disabled={!isEditing}
                    id="filled-basic"
                    label={translate('resources.infoPage.genericQRCaster.wifi_ssid')}
                    value={wifiSSID}
                    onChange={textOnChange('wifiSSID')}
                    style={{ width: 500 }}
                    endDom={<CustomPoper
                        color={'#e5f1f8'}
                        fontSize={'11px'}
                        open={openPoper}
                        handleClick={() => setOpenPopper(true)}
                        handleClose={() => setOpenPopper(false)}
                        title={translate('resources.infoPage.genericQRCaster.wifi_ssid')}
                        content={translate('resources.infoPage.genericQRCaster.wifi_ssid_content')}
                        icon={<b>?</b>}
                    />}
                />
            </Box>
            <Box style={{ marginTop: 20 }} >
                <OneLineTextField
                    disabled={!isEditing}
                    id="filled-basic"
                    label={translate('resources.infoPage.genericQRCaster.cast_device_name')}
                    value={castDeviceName}
                    name='cast device name'
                    onChange={textOnChange('castDeviceName')}
                    style={{ width: 500 }}
                    endDom={<CustomPoper
                        color={'#e5f1f8'}
                        fontSize={'11px'}
                        open={openPoper}
                        handleClick={() => setOpenPopper(true)}
                        handleClose={() => setOpenPopper(false)}
                        title={translate('resources.infoPage.genericQRCaster.cast_device_name')}
                        content={translate('resources.infoPage.genericQRCaster.cast_device_name_content')}
                        icon={<b>?</b>}
                    />}
                />
            </Box>
            <Box style={{ marginTop: 20 }} >
                <OneLineTextField
                    disabled={!isEditing || wifiEncryptionType === WIFI_ENCRYPTION_TYPES[0].name}
                    id="filled-basic"
                    label={translate('resources.infoPage.genericQRCaster.wifi_password')}
                    value={wifiPassword}
                    name='wifi password'
                    onChange={textOnChange('wifiPassword')}
                    type='text'
                    autoComplete='wifi-password'
                    password={true}
                    style={{ width: 500 }}
                    endDom={<CustomPoper
                        color={'#e5f1f8'}
                        fontSize={'11px'}
                        open={openPoper}
                        handleClick={() => setOpenPopper(true)}
                        handleClose={() => setOpenPopper(false)}
                        title={translate('resources.infoPage.genericQRCaster.wifi_password')}
                        content={translate('resources.infoPage.genericQRCaster.wifi_password_content')}
                        icon={<b>?</b>}
                    />}
                />
            </Box>
            <Box style={{ width: 500, marginTop: 20 }} >
                <SelectBoxFilter
                    disabled={!isEditing}
                    data={WIFI_ENCRYPTION_TYPES}
                    label={translate('resources.infoPage.genericQRCaster.wifi_encryption_type')}
                    value={wifiEncryptionType}
                    onChange={(value) => onChangeQRCaster({ wifiEncryptionType: value.name })}
                    keyName='name'
                    placeholder={translate('resources.infoPage.filter_wifi_encryption_type')}
                />
            </Box>
            <Box style={{ width: 500, marginTop: 20 }} >
                <SelectBoxFilter
                    disabled={!isEditing}
                    data={LIST_INPUT_DEVICE}
                    label={translate(`resources.infoPage.genericQRCaster.cast_device_input`)}
                    value={getInputDeviceLabel(castDeviceInput, translate)}
                    onChange={(value) => onChangeQRCaster({ castDeviceInput: value.id })}
                    keyName='label'
                    placeholder={translate('resources.infoPage.filter_cast_device_input')}
                />
            </Box>
        </Box>
    )
}

export default GenericQRCaster;
